import { AlertBox, Icon } from '@iwoca/orion';
import styles from '../InformationBanners.module.css';
import { FormattedMessage } from 'react-intl';
import messages from './DocUploadBanner.messages';
import { NEW_IwLink } from '@iwRouter/NEW_IwLink';
import { tracking } from '@iwoca/frontend-tracking-library';

export const DocUploadBanner = () => {
    return (
        <div data-testid="doc-upload-banner" role="banner">
            <AlertBox className={styles.banner} variant="cancel">
                <div className={styles.bannerIcon}>
                    <Icon icon="infoCircleOutline" />
                </div>

                <div className={styles.content}>
                    <FormattedMessage
                        {...messages.description}
                        values={{
                            docUploadLink: (
                                <NEW_IwLink
                                    onClick={() =>
                                        tracking.ampli.docUploadBannerLinkClicked()
                                    }
                                    to={{ pathname: '/trading/' }}
                                >
                                    here
                                </NEW_IwLink>
                            )
                        }}
                    />
                </div>
            </AlertBox>
        </div>
    );
};
